<template>
  <div class="navContainer">
    <!-- <div class="router"> -->
    <div class="logoImg">
      <img src="../assets/889.png" alt="">
    </div>
    <ul class="routerContainer">

      <li class="nav"><router-link to="/">首页</router-link></li>
      <li class="nav">
        <router-link to="/Product"> 产品中心</router-link>
        <div class="subContainer">
          <ul class="subList">
            <li><router-link to="/Product/Parking">智慧停车</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Charging">智慧充电</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Community">智慧社区</router-link></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </li>
      <li class="nav"><router-link to="/SmartCloud">Smart云平台</router-link></li>
      <li class="nav"><router-link to="/Solution">解决方案 </router-link>
        <div class="subContainer">
          <ul class="subList">
            <li><router-link to="/Product/Parking">智慧停车</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Charging">智慧充电</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Community">智慧社区</router-link></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </li>
      <li class="nav"><router-link to="/Cases"> 应用案例 </router-link>
        <div class="subContainer">
          <ul class="subList">
            <li><router-link to="/Product/Parking">智慧停车</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Charging">智慧充电</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Community">智慧社区</router-link></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </li>
      <li class="nav"><router-link to="/Service"> 服务与支持</router-link>
        <div class="subContainer">
          <ul class="subList">
            <li><router-link to="/Product/Parking">智慧停车</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Charging">智慧充电</router-link></li>
            <li></li>
            <li></li>
          </ul>
          <ul class="subList">
            <li><router-link to="/Product/Community">智慧社区</router-link></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </li>
      <li class="nav"><router-link to="/About"> 关于我们 </router-link></li>

    </ul>
    <!-- </div> -->
    <div class="logoHotLine">
      <img src="../assets/hotLine.png" alt="">
    </div>
  </div>
</template>
<style scoped>
ul,
a {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  color: #000;
}
.navContainer {
  display: flex;
  justify-content: center;
  background-color: #bec1c0;
}
.routerContainer {
  /* margin-top: 5px; */
  width: 70%;
  height: 100px;
  /* border: 1px solid red; */
  /* background-color: #bec1c0; */
  display: flex;
  justify-content: center;
}

.routerContainer>li {
  height: 99px;
  /* border: 1px solid skyblue; */
  padding: 0 40px;
  font-family: "Microsoft YaHei";
  font-size: 40px;
  /* color: #000; */
  text-align: center;
  line-height: 99px;
  position: relative;
}

.subContainer {
  width: 900px;
  /* border: 1px solid yellow; */
  background-color:#bec1c0cf;
  display: flex;
  visibility: hidden;
  position: absolute;
  left: -50%;
  top: 120px;
  z-index: 1202;
}

.subContainer .subList {
  width: 300px;
  height: 100px;
  border: 1px solid black;
  border-left: #bec1c0;
  border-top: #bec1c0;
  border-bottom: #bec1c0;
}
.subContainer :last-child {
  border-right: #bec1c0;
}
.subList a {
  font-size: 30px;
}
.logoImg {
  width: 300px;
  height: 90px;
  /* background-color: #bec1c0; */
  /* margin-right: 220px; */
}

.logoImg img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logoHotLine {
  width: 430px;
  height: 94px;
  /* margin-left: 220px; */
}

.routerContainer>li:hover {
  transform: translateY(-20px);
  /* box-shadow: 0 20px 25px -15px rgba(0, 0, 0, 0.1), 0 10px 10px -15px rgba(0, 0, 0, 0.04); */
  box-shadow: 0 25px 35px -10px rgba(0, 0, 0, 0.15), 0 15px 15px -10px rgba(0, 0, 0, 0.06);

}

.routerContainer>li:hover .subContainer {
  visibility: visible;
}
</style>